import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../../resources/helper/helper";
import {
  getAllProducts,
  getRecentlyAddedProducts,
  getTopRatedProducts,
  getTopSellingProducts,
  getTrendingProducts,
} from "../../redux/features/productSlice";
import { toast } from "react-toastify";
import { useEffect, useLayoutEffect, useState } from "react";
import ProductCard from "../../Components/ProductCard";
import TopSellingProduct from "../../Components/TopSellingProduct";
import TrendingProducts from "../../Components/TrendingProducts";
import RecentlyAddedProducts from "../../Components/RecentlyAddedProducts";
import TopRatedProducts from "../../Components/TopRatedProducts";
import CategoriesSideBar from "../../Components/CategoriesSideBar";
import { getAllCategories } from "../../redux/features/categorySlice";
import { CircularProgress, Pagination } from "@mui/material";

function Home() {
  const dispatch = useDispatch();
  const token = getToken();
  const { loading, products } = useSelector((state) => state.product);
  const [count, setCount] = useState(0);
  const [currentProducts, setCurrentProducts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const handlePaggination = (data) => {
    const productsPerPage = 10;

    const totalPages = Math.ceil(data.length / productsPerPage);
    setCount(totalPages);

    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    const currentProducts = data.slice(indexOfFirstProduct, indexOfLastProduct);
    setCurrentProducts(currentProducts);
  };

  useEffect(() => {
    if (products) {
      handlePaggination(products);
    }
  }, [products]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  useLayoutEffect(() => {
    dispatch(getAllProducts(token))
      .unwrap()
      .then((res) => {
        console.log("Get Products from home", res);
      })
      .catch((err) => {
        toast.error(err, {
          position: "top-center",
          theme: "colored",
        });
      });
  }, []);
  useLayoutEffect(() => {
    if (token) {
      dispatch(getAllCategories(token))
        .unwrap()
        .then((res) => {
          console.log("Get Categories", res);
        })
        .catch((err) => {
          console.log("Get Categories", err);
        });
    }
  }, []);

  useLayoutEffect(() => {
    dispatch(getTopRatedProducts(token))
      .unwrap()
      .then((res) => {
        console.log("getTopRatedProducts", res);
      })
      .catch((err) => {
        toast.error(err, {
          position: "top-center",
          theme: "colored",
        });
      });
  }, []);

  useLayoutEffect(() => {
    dispatch(getTopSellingProducts(token))
      .unwrap()
      .then((res) => {
        console.log("getTopSellingProducts", res);
      })
      .catch((err) => {
        toast.error(err, {
          position: "top-center",
          theme: "colored",
        });
      });
  }, []);

  useLayoutEffect(() => {
    dispatch(getRecentlyAddedProducts(token))
      .unwrap()
      .then((res) => {
        console.log("getRecentlyAddedProducts", res);
      })
      .catch((err) => {
        toast.error(err, {
          position: "top-center",
          theme: "colored",
        });
      });
  }, []);

  useLayoutEffect(() => {
    dispatch(getTrendingProducts(token))
      .unwrap()
      .then((res) => {
        console.log("getTrendingProducts", res);
      })
      .catch((err) => {
        toast.error(err, {
          position: "top-center",
          theme: "colored",
        });
      });
  }, []);

  return (
    <div>
      <main className="main">
        <section className="home-slider position-relative mb-30">
          <div className="container">
            <div className="row">
              <div className="col-lg-9">
                <div className="home-slide-cover mt-30">
                  <div className="hero-slider-1 style-5 dot-style-1 dot-style-1-position-2">
                    <div
                      className="single-hero-slider single-animation-wrap"
                      style={{
                        backgroundImage:
                          "url(assets/imgs/slider/banners11.png)",
                      }}
                    ></div>
                  </div>
                  <div className="slider-arrow hero-slider-1-arrow" />
                </div>
              </div>
              <div className="col-lg-3">
                <div className="row">
                  <div className="col-md-6 col-lg-12">
                    <div className="banner-img style-4 mt-20">
                      <img src="assets/imgs/banner/sidebar1.png" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-12">
                    <div className="banner-img style-5 mt-5 mt-md-30">
                      <img src="assets/imgs/banner/sidebar2.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*End hero slider*/}
        <section className="popular-categories section-padding">
          <div className="container wow animate__animated animate__fadeIn">
            <div className="section-title">
              <div className="title">
                <h3>Featured Categories</h3>
              </div>
              <div
                className="slider-arrow slider-arrow-2 flex-right carausel-10-columns-arrow"
                id="carausel-10-columns-arrows"
              />
            </div>
          </div>
        </section>
        {/*End category slider*/}
        <section className="banners mb-25">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div
                  className="banner-img wow animate__animated animate__fadeInUp"
                  data-wow-delay={0}
                >
                  <img src="assets/imgs/banner/banner-1.png" alt="" />
                  <div className="banner-text">
                    <h4>
                      Everyday Fresh &amp; <br />
                      Clean with Our
                      <br />
                      Products
                    </h4>
                    <a className="btn btn-xs">
                      Shop Now <i className="fi-rs-arrow-small-right" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div
                  className="banner-img wow animate__animated animate__fadeInUp"
                  data-wow-delay=".2s"
                >
                  <img src="assets/imgs/banner/banner-2.png" alt="" />
                  <div className="banner-text">
                    <h4>
                      Make your Breakfast
                      <br />
                      Healthy and Easy
                    </h4>
                    <a className="btn btn-xs">
                      Shop Now <i className="fi-rs-arrow-small-right" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 d-md-none d-lg-flex">
                <div
                  className="banner-img mb-sm-0 wow animate__animated animate__fadeInUp"
                  data-wow-delay=".4s"
                >
                  <img src="assets/imgs/banner/banner-3.png" alt="" />
                  <div className="banner-text">
                    <h4>
                      The best Organic <br />
                      Products Online
                    </h4>
                    <a className="btn btn-xs">
                      Shop Now <i className="fi-rs-arrow-small-right" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*End banners*/}
        <section className="product-tabs section-padding position-relative">
          <div className="container row col-sm-12 col-12">
            <CategoriesSideBar />
            <div className="col-10">
              <div className="section-title style-2 wow animate__animated animate__fadeIn">
                <h3>Popular Products</h3>
              </div>
              {/*End nav-tabs*/}
              <div className="tab-pane fade show active">
                <div className="row product-grid-4">
                  {loading ? (
                    <div
                      style={{
                        width: "100%",
                        height: 400,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgress size={30} color="secondary" />
                    </div>
                  ) : products &&
                    currentProducts?.length > 0 &&
                    products?.length > 0 ? (
                    currentProducts?.map((product) => (
                      <ProductCard
                        key={product?._id}
                        productId={product?._id}
                        name={product?.name}
                        category={product?.category}
                        description={product?.description}
                        price={product?.price}
                        discount_price={product?.discount_price}
                        featured_media={product?.featured_media}
                        media={product?.media}
                        ratings={product?.ratings}
                        stock={product?.stock}
                        product={product}
                      />
                    ))
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: 400,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <p>No products available</p>
                    </div>
                  )}
                </div>
              </div>
              <Pagination
                count={count}
                page={currentPage}
                onChange={handlePageChange}
                color="secondary"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
                disabled={loading} // Disable pagination when loading
              />
              {/* <div className="tab-content">
                
              </div> */}
            </div>
          </div>
        </section>

        <section className="section-padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div
                  className="banner-img style-6 wow animate__animated animate__fadeInUp"
                  data-wow-delay={0}
                >
                  <img src="assets/imgs/banner/banner-16.png" alt="" />
                  <div className="banner-text">
                    <h6 className="mb-10 mt-30">
                      Everyday Fresh with
                      <br />
                      Our Products
                    </h6>
                    <p>Go to supplier</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div
                  className="banner-img style-6 wow animate__animated animate__fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <img src="assets/imgs/banner/banner-17.png" alt="" />
                  <div className="banner-text">
                    <h6 className="mb-10 mt-30">
                      100% guaranteed all
                      <br />
                      Fresh items
                    </h6>
                    <p>Go to supplier</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div
                  className="banner-img style-6 wow animate__animated animate__fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <img src="assets/imgs/banner/banner-18.png" alt="" />
                  <div className="banner-text">
                    <h6 className="mb-10 mt-30">
                      Special grocery sale
                      <br />
                      off this month
                    </h6>
                    <p>Go to supplier</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div
                  className="banner-img style-6 wow animate__animated animate__fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <img src="assets/imgs/banner/banner-19.png" alt="" />
                  <div className="banner-text">
                    <h6 className="mb-10 mt-30">
                      Enjoy 15% OFF for all
                      <br />
                      vegetable and fruit
                    </h6>
                    <p>Go to supplier</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/*End Deals*/}
        <section className="section-padding mb-30">
          <div className="container">
            <div className="row">
              <TopSellingProduct />
              <TrendingProducts />
              <RecentlyAddedProducts />
              <TopRatedProducts />
            </div>
          </div>
        </section>
        {/*End 4 columns*/}
      </main>
    </div>
  );
}

export default Home;
